function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { Link } from '../Link';
import { Popover } from '../Popover';
import { Skeleton } from '../Skeleton';
import { Tag } from '../Tag';
import useIsMobile from '../Utils/customHooks/useIsMobile';
import { generateUniqueId } from '../Utils/helper';
import ChevronUp from '@dtsl/icons/dist/icons/react/ChevronUp';
import Lock from '@dtsl/icons/dist/icons/react/Lock';
import { onCollapsable } from '@dtsl/react/dist/components/Utils/collapsible';
import '@dtsl/css-sidebar/dist/index.css';
export function IsMobile() {
  let viewPort = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1025;
  const {
    isMobile
  } = useIsMobile(viewPort);
  return isMobile;
}
function Sidebar(props) {
  const {
    links,
    isLoading,
    statsMetaData,
    isStatsMetaDataLoading
  } = props;
  const [visible, setVisible] = useState(false);
  const isMobile = IsMobile();
  const renderlink = item => {
    const {
      svg,
      to = '#',
      title = '',
      target = '_self',
      active = false,
      locked = false,
      onClick = () => {},
      tagData = null,
      popoverMetaData,
      closeOnClick = locked && !!popoverMetaData ? false : true
    } = item;
    const sidebarControlClasses = classNames({
      'sib-sidebar__control': true,
      'sib-sidebar__control--active': active,
      'sib-sidebar__control--locked': locked
    });
    const onClickLink = event => {
      if (locked || to === '#') {
        event.preventDefault();
        event.stopPropagation();
      }
      if (closeOnClick) {
        setVisible(false);
      }
      onClick(event);
    };
    const sidebarHTML = /*#__PURE__*/React.createElement("a", {
      id: `sdBarItem-${generateUniqueId()}`,
      role: "menuitem",
      key: title,
      target: target,
      href: locked ? '#' : to,
      onClick: onClickLink,
      className: sidebarControlClasses
    }, /*#__PURE__*/React.createElement("span", {
      className: "sib-sidebar__label"
    }, svg ? /*#__PURE__*/React.cloneElement(svg, {
      className: 'sib-sidebar__icon'
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: "sib-sidebar__label--text"
    }, title), tagData ? /*#__PURE__*/React.createElement(Tag, _extends({}, tagData, {
      color: "gold"
    })) : null), locked && /*#__PURE__*/React.createElement(Lock, {
      className: "icon-right",
      color: "var(--sib-color_content-secondary)"
    }));
    return /*#__PURE__*/React.createElement("li", {
      key: title
    }, locked && !!popoverMetaData ? /*#__PURE__*/React.createElement(Popover, _extends({
      placement: isMobile ? 'bottom-end' : 'right'
    }, popoverMetaData, {
      trigger: ['click']
    }), sidebarHTML) : sidebarHTML);
  };
  const renderCollpsableLinks = item => {
    const {
      title = '',
      svg,
      items = [],
      active,
      collapsed = false
    } = item;
    const sidebarCollapsableControlClasses = classNames({
      'sib-sidebar__control': true,
      'sib-sidebar__control--active': active,
      'sib-collapsible__trigger ': true,
      'sib-collapsible__trigger_toggled': !collapsed
    });
    const sidebarNestedClasses = classNames({
      'sib-sidebar__section--nested': true,
      'sib-collapsible__content': true,
      'sib-collapsible__content_toggled': !collapsed
    });
    return /*#__PURE__*/React.createElement("li", {
      key: title,
      className: "sib-collapsible"
    }, /*#__PURE__*/React.createElement("button", {
      "aria-expanded": collapsed,
      className: sidebarCollapsableControlClasses,
      onClick: onCollapsable
    }, /*#__PURE__*/React.createElement("span", {
      className: "sib-sidebar__label"
    }, svg ? /*#__PURE__*/React.cloneElement(svg, {
      className: 'sib-sidebar__icon'
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: "sib-sidebar__label--text"
    }, title)), /*#__PURE__*/React.createElement(ChevronUp, {
      className: "sib-collapsible__arrow"
    })), /*#__PURE__*/React.createElement("ul", {
      className: sidebarNestedClasses,
      "data-collapsible-behavior": "shutter"
    }, items.map(item => renderlink(item))));
  };
  const onKeyUp = event => {
    if (event.keyCode === 13) {
      document.activeElement.click();
    }
  };
  const onClickHandler = event => {
    if (event.target.checked) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: visible,
    onKeyUp: onKeyUp,
    onClick: onClickHandler,
    "aria-label": "sidebar-menu",
    className: "sib-sidebar__menu-checkbox"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sib-sidebar__menu-icon"
  }), isMobile ? /*#__PURE__*/React.createElement("div", {
    className: `sib-sidebar-backdrop ${visible ? 'backdrop--visible' : ''}`
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "sib-sidebar"
  }, !isLoading ? /*#__PURE__*/React.createElement("nav", {
    className: "sib-sidebar__section",
    "aria-label": "Sidebar nav"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "sib-sidebar__list",
    role: "menu"
  }, links.map(item => {
    const {
      type
    } = item;
    if (type === 'COLLAPSABLE_LIST') {
      return renderCollpsableLinks(item);
    } else {
      return renderlink(item);
    }
  }))) : Array(7).fill(1).map((val, index) => /*#__PURE__*/React.createElement("div", {
    className: "",
    key: val * index,
    style: {
      padding: '12px 16px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    width: 184,
    height: 24
  })))), !isStatsMetaDataLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(statsMetaData).map(stat => {
    const {
      title,
      value,
      linkMetaData,
      buttonMetaData,
      titleIcon
    } = statsMetaData[stat];
    return /*#__PURE__*/React.createElement("section", {
      key: stat,
      className: "sib-sidebar__section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "sib-sidebar__heading-wrapper"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "sib-sidebar__heading",
      style: titleIcon && {
        paddingRight: 0
      }
    }, title), titleIcon && /*#__PURE__*/React.createElement("span", {
      className: "sib-sidebar__heading-icon"
    }, titleIcon)), /*#__PURE__*/React.createElement("div", {
      className: "sib-sidebar__content"
    }, value, linkMetaData && /*#__PURE__*/React.createElement(Link, _extends({
      className: "sib-sidebar__content--link"
    }, linkMetaData)), buttonMetaData && /*#__PURE__*/React.createElement(Button, _extends({
      className: "sib-sidebar__content--btn"
    }, buttonMetaData))));
  })) : Object.keys(statsMetaData).map(stat => {
    return /*#__PURE__*/React.createElement("section", {
      key: stat,
      className: "sib-sidebar__section"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "sib-sidebar__heading"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      width: 118,
      height: 20
    })), /*#__PURE__*/React.createElement("div", {
      className: "sib-sidebar__content"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      width: 148,
      height: 20
    }), /*#__PURE__*/React.createElement(Skeleton, {
      width: 97,
      height: 20
    })));
  })));
}
export default Sidebar;
Sidebar.defaultProps = {
  links: [],
  isLoading: false,
  statsMetaData: {},
  isStatsMetaDataLoading: false
};
Sidebar.propTypes = {
  isLoading: PropTypes.bool,
  statsMetaData: PropTypes.object,
  isStatsMetaDataLoading: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.shape({
    to: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    target: PropTypes.string,
    title: PropTypes.string,
    active: PropTypes.bool,
    locked: PropTypes.bool,
    popoverMetaData: PropTypes.object,
    onClick: PropTypes.func,
    svg: PropTypes.node,
    type: PropTypes.string,
    items: PropTypes.array,
    collapsed: PropTypes.bool
  }))
};